import PropTypes from 'prop-types';
import React from 'react';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import AccessibleTooltip from './AccessibleTooltip';

class AddButton extends React.Component {

    render() {

        return (
            <AccessibleTooltip title={this.props.title}>
                <span>
                    <IconButton
                        aria-keyshortcuts={this.props.shortcut}
                        color={this.props.color}
                        aria-label={this.props.title}
                        disabled={this.props.disabled}
                        data-test={this.props.dataTest}
                        size="small"
                        onClick={this.props.onClick}>
                        {this.props.icon}
                    </IconButton>
                </span>
            </AccessibleTooltip>
        );
    }
}

AddButton.defaultProps = {
    icon: <AddCircleIcon />,
    disabled: false,
};

AddButton.propTypes = {
    shortcut: PropTypes.string,
    dataTest: PropTypes.string,
    disabled: PropTypes.bool,
    color: PropTypes.string,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

export default AddButton;